<script setup lang="ts">
// @ts-nocheck

import { ref, onMounted, computed } from "vue";
import { APIURL } from "@/defaults";
import type { Ref } from "vue";
import type { UserData } from "@/interfaces/interfaces";

const emit = defineEmits(["loginComplete"]);

const loginUri = computed(() => `${APIURL}/login`);

const onSignIn = (user) => {
    const profile = user.getBasicProfile();
};

const loading: Ref<boolean> = ref(true);
const error: Ref<string | null> = ref(null);

const handleCredentialResponse = (response) => {
    //console.log("Encoded JWT ID token: " + response.credential);
    //console.log(response)

    fetch(`${APIURL}/token`, {
        credentials: "include",
        method: "POST",
        body: JSON.stringify({ google_token: response.credential }),
        headers: {
            "content-type": "application/json",
        },
    })
        .then((r) => {
            if (r.status !== 200) {
                throw Error("login not successfull");
            }
            return r.json();
        })
        .then((r) => {
            if(r.loggedin) {
                fetchUserData();
            }
        })
        .catch((err) => {
            error.value = "Login not successfull, you might not have permission to view the Dashboard";
        });
};

const fetchUserData = () => {
    fetch(`${APIURL}/me`, {
        credentials: "include",
    })
        .then((r) => {
            if (r.status !== 200) {
                throw Error("login not successfull");
            }
            return r.json() as UserData;
        })
        .then((r: UserData) => {
            if (r) {
                emit("loginComplete", r);
                loading.value = false;
                error.value = null;
            } else {
                loading.value = false;
                error.value = r.detail;
            }
        })
        .catch((err) => {
            loading.value = false;
            google.accounts.id.initialize({
                client_id: "618053671614-1r83ulfv8agl6c6ind8n8l7hfu39m3t1.apps.googleusercontent.com",
                callback: handleCredentialResponse,
            });
            google.accounts.id.prompt();
        });
}

onMounted(() => {
    fetch(`${APIURL}/me`, {
        credentials: "include",
    })
        .then((r) => {
            if (r.status === 401) {
                google.accounts.id.initialize({
                    client_id: "618053671614-1r83ulfv8agl6c6ind8n8l7hfu39m3t1.apps.googleusercontent.com",
                    callback: handleCredentialResponse,
                });
                google.accounts.id.prompt();
                loading.value = false;
            } else if (r.status === 200) {
                return r.json() as UserData;
            } else {
                throw Error("Connection failed");
            }
            return null;
        })
        .then((r: UserData) => {
            if (r) {
                emit("loginComplete", r);
                loading.value = false;
                error.value = null;
            } else {
                loading.value = false;
            }
        })
        .catch((err) => {
            loading.value = false;
            error.value = "The server is not responding currently. It might be down for a few minutes of maintenance.";
        });
});
</script>

<template>
    <main>
        <div v-show="!loading">
            <div v-if="!error" class="login-wrapper">

                <div id="g_id_onload"
                    data-client_id="618053671614-1r83ulfv8agl6c6ind8n8l7hfu39m3t1.apps.googleusercontent.com"
                    :data-login_uri="loginUri" data-auto_prompt="false">
                </div>
                <div class="g_id_signin"></div>
            </div>
            <div v-else class="error-wrapper">
                <h1>Sorry</h1>
                <p>{{ error }}</p>
            </div>
        </div>
    </main>
</template>

<style scoped>
.login-wrapper {
    padding: 20px;
    max-width: 300px;
    margin: 0 auto;
    text-align: center;
}

.g_id_signin {
    margin: 20px 0;
}

.error-wrapper {
    display: flex;
    height: 90vh;
    flex-flow: column;
    justify-content: center;
    align-items: center;
    font-size: 18px;
    color: #666;
}
.error-wrapper h1 {
    text-transform: uppercase;
    font-weight: 800;
    font-size: 4em;
}
.error-wrapper p {
    max-width: 400px;
    text-align: center;
    margin-bottom: 1em;
}
</style>
